import LockUser from './LockUser';
export default LockUser;
